export default __webpack_public_path__ + "static/media/nine.c4203b2a.svg";